export const TOKEN_EXPIRY_BUFFER = 5 * 60 * 1000;
